/**
 * VerticalViewer Component
 * Renders webtoon images in a vertical scroll layout.
 * 
 * @param {HTMLElement} container - Container to render into.
 * @param {Object} props
 * @param {Array} props.images - Array of image URLs.
 * @param {Function} props.onNext - Callback for next episode.
 * @param {Function} props.onPrev - Callback for prev episode.
 * @param {boolean} props.hasPrev - Whether duplicate previous button should be enabled.
 * @param {boolean} props.hasNext - Whether duplicate next button should be enabled.
 */
export const VerticalViewer = (container, { images, onNext, onPrev, hasPrev, hasNext }) => {
    // 1. Inject Styles (Moved to public/viewer.css)
    // Style injection block removed.

    // 2. Render Template
    // Note: The Page container will handle the main wrapper (width/margins).
    // The Viewer just fills it.

    // Image List
    const imageListHtml = images.map((url, index) => {
        // Proxy Logic (Inline for simplicity, assuming helper function isn't available or just reusing logic)
        let finalUrl = url;
        if (url.includes('pstatic.net') || url.includes('naver.com') || url.includes('daumcdn.net')) {
            finalUrl = "https://wsrv.nl/?url=" + encodeURIComponent(url) + "&w=800&output=webp";
        }

        return `
            <div class="webtoon-image-wrapper">
                <img src="${finalUrl}" 
                     class="webtoon-image" 
                     loading="${index < 3 ? 'eager' : 'lazy'}" 
                     decoding="async" 
                     alt="Page ${index + 1}"
                     onerror="if(!this.src.includes('wsrv.nl')) this.src='https://wsrv.nl/?url='+encodeURIComponent('${url}')"
                     oncontextmenu="return false;"
                />
            </div>
        `;
    }).join('');

    container.innerHTML = `
        <div id="toon-container" class="flex flex-col items-center w-full min-h-[500px] bg-white">
            ${images.length > 0 ? imageListHtml : "<div class='p-10 text-black'>No Images Found</div>"}
        </div>

        <!-- Navigation & Actions consolidated into ViewerFooter -->

    `;

    // 3. Bind Events
    const btnPrev = container.querySelector('#vv-btn-prev');
    const btnNext = container.querySelector('#vv-btn-next');

    if (btnPrev && hasPrev) {
        btnPrev.onclick = (e) => {
            e.stopPropagation();
            onPrev();
        };
    }

    if (btnNext) {
        btnNext.onclick = (e) => {
            e.stopPropagation();
            onNext();
        };
    }

    // Scroll Top Button logic is global/page level usually, or we can add it here. 
    // The Page container handles "global fixed elements" like Header. 
    // I will leave Scroll Top Button as a Page responsibility or a global util, 
    // but the request asked to modularize rendering.
    // The original `scroll-top-btn` was in the page markup. I'll omit it here for simplicity/focus on content, 
    // or the Page should render it.
};
